import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectProfile } from '@webapp/account/src/resources/profile/selectors';
import { AccountRoutes } from '@webapp/account/src/resources/routes';
import { getSuperAdminUsers } from '@webapp/account/src/resources/users';

import { ArrowDown, ProfileBtn } from '@webapp/common/assets/icons';
import { useAction } from '@webapp/common/hooks/use-actions';
import { IGNORE_CLICK_OUTSIDE } from '@webapp/common/hooks/use-click-outside';
import { getPrevUserToken } from '@webapp/common/lib/cookies';

import { SuperAdminModal } from './super-admin-modal';

import css from './header.css';

const HeaderAuthMenuCommon: FC<{ className?: string }> = ({ className }) => (
    <a className={cn(css.link, className)} href={AccountRoutes.account.link}>
        <ProfileBtn className={css.icon} />
        <div className={css.personalAccount}>Личный кабинет</div>
    </a>
);

export const HeaderAuthMenuAccount = () => {
    const [showSuperAdminUsers, setShowSuperAdminUsers] = useState<boolean>(false);

    const profile = useSelector(selectProfile);
    const isSuperAdmin = profile.superadmin;
    const isSuperAdminUser = profile.superadminUser;
    const prevToken = getPrevUserToken();
    const hasPreviousToken = Boolean(isSuperAdminUser && prevToken);

    const getSuperAdminUsersRequest = useAction(getSuperAdminUsers);

    useEffect(() => {
        if (isSuperAdmin) {
            getSuperAdminUsersRequest();
        }
    }, [isSuperAdmin, getSuperAdminUsersRequest]);

    return (
        <div className={css.auth}>
            {isSuperAdmin || isSuperAdminUser ? (
                <>
                    <div className={cn(css.link, css.account, IGNORE_CLICK_OUTSIDE)}>
                        <a href={AccountRoutes.account.link}>
                            <ProfileBtn className={css.icon} />
                        </a>
                        <div className={css.accountName} onClick={() => setShowSuperAdminUsers(!showSuperAdminUsers)}>
                            {isSuperAdminUser ? profile?.email : profile?.nikname}
                            {(hasPreviousToken || !isSuperAdminUser) && (
                                <ArrowDown className={cn(css.arrowIcon, showSuperAdminUsers && css.rotatePlus180)} />
                            )}
                        </div>
                    </div>
                    {showSuperAdminUsers && (
                        <SuperAdminModal
                            nikname={profile.nikname}
                            email={profile.email}
                            onClose={() => setShowSuperAdminUsers(false)}
                            showPrevUser={hasPreviousToken}
                            prevToken={prevToken}
                        />
                    )}
                </>
            ) : (
                <HeaderAuthMenuCommon />
            )}
        </div>
    );
};

export const HeaderAuthMenuLanding = () => (
    <div className={css.auth}>
        <HeaderAuthMenuCommon className={css.landing} />
    </div>
);
